export default __webpack_public_path__ + "static/media/outcess10.82519578.jpeg";